import { render, staticRenderFns } from "./PvpCounters.vue?vue&type=template&id=4dc9cc42&scoped=true&lang=pug&"
import script from "./PvpCounters.vue?vue&type=script&lang=js&"
export * from "./PvpCounters.vue?vue&type=script&lang=js&"
import style0 from "./PvpCounters.vue?vue&type=style&index=0&id=4dc9cc42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc9cc42",
  null
  
)

export default component.exports